<ng-container
  *ngIf="{
    result: result$ | async,
    searchCompanyLoading: searchCompanyLoading$ | async,
    addCompanyLoading: addCompanyLoading$ | async,
    userCompaniesLoading: userCompaniesLoading$ | async,
    selectedValue: inputSelectedValue$ | async,
  } as obs"
>
  <sd-input-autocomplete
    color="white"
    placeholder="Найти по ИНН, ОГРН или названию"
    [items]="obs.result"
    [loading]="obs.searchCompanyLoading"
    [disabled]="obs.addCompanyLoading"
    (changeInput)="inputEnteredValue$.next($event)"
    (setInput)="inputSelectedValue$.next($event)"
    [itemTemplate]="itemTemplate"
  ></sd-input-autocomplete>

  <ng-template #itemTemplate let-item>
    <div class="item">
      <div class="item-label">{{ item.label }}</div>
      <div *ngIf="item.value" class="item-description">
        <ng-container *ngIf="item.value.vatID">ИНН: {{ item.value.vatID }}</ng-container>
        <ng-container *ngIf="item.value.debtorKPP">, КПП: {{ item.value.debtorKPP }}</ng-container>
        <ng-container *ngIf="item.value.contactAddress">, {{ item.value.contactAddress }}</ng-container>
      </div>
    </div>
  </ng-template>

  <br />

  <button
    sdButton
    *ngIf="obs.selectedValue"
    [loading]="obs.addCompanyLoading || obs.userCompaniesLoading"
    [disabled]="obs.addCompanyLoading || obs.userCompaniesLoading"
    class="btn-add-company"
    (click)="onAddCompanyBtnClick(obs.selectedValue)"
  >
    Добавить
  </button>
</ng-container>
